<template>
    <VSwitch v-bind="$attrs" :class="classList" v-on="$listeners" />
</template>

<script>
import { USER_INPUT_CLASS } from '../../utils/classNames';

export default {
    name: 'SrSwitch',
    model: {
        prop: 'inputValue',
        event: 'change',
    },
    computed: {
        classList() {
            return [USER_INPUT_CLASS];
        },
    },
};
</script>
